import { strategyToOptions } from '@/common/utils/strategyToOptions'

export const billIntegrationProcess = {
  automatic: 'Automaticamente',
  manual: 'Manualmente',
  none: 'Nunca',
}

export const billIntegrationProcessOptions = strategyToOptions(billIntegrationProcess)
